import { editable } from '@/src/tools/contentModulesFieldName';
import { EPreviewSize } from '@/src/types/common/SalesChannel';

export const getEditableStatus = (getFieldValue, id, breakpoint) => {
  const is_editable = getFieldValue([`${id}_${editable}`]);
  return is_editable || breakpoint === EPreviewSize.WIDE;
};
